export enum WideoDefVersion {
  V36 = 3.6,
  V37 = 3.7,
  V38 = 3.8, // changed architecture of transitions for scene
  V40 = 4.0, // Removed inner object in TextObjects (in the process removing the alignment of text using the x and y
  // attributes of the inner object)
  V41 = 4.1, // Removed TextComponentProperties wordWrap, wordWrapWidth, breakWords and replaced lineHeight with
  V411 = 4.11, // OpenSans_v2 changed name to OpenSans_Light
  V42 = 4.2, // Added properties width, height and version on scenes
  V43 = 4.3, // Added property presentationMode. Player setting
  V44 = 4.4, // Conditional transform (only run on selected converted wideo templates),
  V45 = 4.5, // Added properties targetId, width, height and type to MaskObject, removed MaskComponent from MaskObject
  V46 = 4.6, // Added property repeat on AudioComponentDef
  V47 = 4.7, // Fixed a bug that displaced shapes by half of the border width and removed non-applied masks
  V48 = 4.8, // Added property ID to keyframes
  V49 = 4.9, // Removed MaskComponent from all Scenes and made the mask an incorporated part of each scene instead
  V50 = 5.0, // Removed Brightness from WideoObject
  V51 = 5.1, // Sanitize fontSize since it is null in some cases and also bring it into range [MIN..MAX]
  V52 = 5.2, // Added scaleXInverted, scaleYInverted to wideoObjects
  V53 = 5.3, // Cleanup fonts OpenSans_v2, NanumMyeongjo that for some reason is circulating among wideos
  V54 = 5.4, // Added audio startTime and endTime
  V55 = 5.5, // Round all object start and end time to hundreds of a second
  V56 = 5.6, // Fixed old animated assets. (animatedImageComponent Replacement)
  V57 = 5.7, // Added property animated to ImageComponent (indicates that a image is an animated GIF), removed loop property from non-animated images
  V58 = 5.8, // Created new ids for all mask objects and target objects inside MaskedObjects and Placeholders to fix a bug with duplicate ids retroactivamente
  V59 = 5.9, // A retroactive fix that fixes all cases of duplicate object ids in all wideo objects
  V60 = 6.0, // Removed scaleXInverted and scaleYInverted to WideoObject, flip is now modeled with negative scale
  V70 = 7.0, // Created an AudioObject between Wideo and AudioComponent and also allow AudiosObjects under scenes
  V71 = 7.1, // Added wideo root property thumbnails which lists the thumbnails for the wideo
  V72 = 7.2, // Added sequence number
  V73 = 7.3, // Added fixScaleToMask property to WideoObject to signal that the object has been created without renderer (AI) and the scale must be fixed to the mask during loading wideo first time
  V74 = 7.4, // Added ScriptComponentDef for text-to-speech and avatar script support
}

//<<<---- update this when you upgrade
export const CURRENT_WIDEO_DEF_VERSION: WideoDefVersion = WideoDefVersion.V74;

export enum Class {
  // Wideo:
  Wideo = 'wideo',
  // WideoObjects:
  WideoObject = 'wideoObject',
  MaskObject = 'maskObject',
  ObjectGroup = 'objectGroup',
  MaskedObject = 'maskedObject',
  Placeholder = 'placeholder',
  ImageObject = 'imageObject',
  TextObject = 'textObject',
  ShapeObject = 'shapeObject',
  AnimatedImageObject = 'animatedImageObject',
  AnimatedGroupObject = 'animatedGroupObject',
  VideoObject = 'videoObject',
  AudioObject = 'audioObject',
  Scene = 'scene',
  // Components:
  MaskComponent = 'mask',
  BackgroundComponent = 'background',
  ImageComponent = 'image',
  AnimatedImageComponent = 'animatedImage',
  AnimatedGroupComponent = 'animatedGroup',
  TransitionComponent = 'transition',
  AnimationComponent = 'animation',
  TextComponent = 'text',
  AudioComponent = 'audio',
  ShapeComponent = 'shape',
  ScriptComponent = 'script',
  VideoComponent = 'video',
}

export enum MaskType {
  Rectangle = 'rectangle',
  Circle = 'circle',
  Ellipse = 'ellipse',
  RoundedRect = 'roundedRect',
  Diamond = 'diamond'
}

export enum ShapeType {
  Arrow = 'arrow',
  Diamond = 'diamond',
  Star = 'star',
  MultipleStar = 'multipleStar',
  Hexagon = 'hexagon',
  Square = 'square',
  Rectangle = 'rectangle',
  RoundedRect = 'roundedRect',
  RoundedSquare = 'roundedSquare',
  Triangle = 'triangle',
  TriangleRectangle = 'triangleRectangle',
  Line = 'line',
  DottedLine = 'dottedLine',
  Ellipse = 'ellipse'
}

export namespace ShapeType {

  export function getShapeTypeFromAssetId(assetId: string): ShapeType {
    let shapeType: ShapeType;
    switch (assetId) {
      case '9223371978361715914': shapeType = ShapeType.RoundedRect; break;
      case '9223371978361715915': shapeType = ShapeType.Star; break;
      case '9223371978361715916': shapeType = ShapeType.Diamond; break;
      case '9223371978361715917': shapeType = ShapeType.MultipleStar; break;
      case '9223371978361715918': shapeType = ShapeType.Hexagon; break;
      case '9223371978361715919': shapeType = ShapeType.Rectangle; break;
      case '9223371978361715920': shapeType = ShapeType.Line; break;
      case '9223371978361715921': shapeType = ShapeType.TriangleRectangle; break;
      case '9223371978361715922': shapeType = ShapeType.Square; break;
      case '9223371978361715923': shapeType = ShapeType.RoundedSquare; break;
      case '9223371978361715924': shapeType = ShapeType.Arrow; break;
      case '9223371978361715925': shapeType = ShapeType.DottedLine; break;
      case '9223371978361715926': shapeType = ShapeType.Triangle; break;
      case '9223371978361715927': shapeType = ShapeType.Ellipse; break;
      default: shapeType = null; break;
    }
    return shapeType;
  }


}

export enum TransitionType {
  Intro = 'intro',
  Outro = 'outro'
}

export enum Tween {
  PopIn = 'popIn',
  PopOut = 'popOut',
  EnlargeIn = 'enlargeIn',
  EnlargeOut = 'enlargeOut',
  FadeIn = 'fadeIn',
  FadeOut = 'fadeOut',
  SlideLeft = 'slideLeft',
  SlideRight = 'slideRight',
  SlideUp = 'slideUp',
  SlideDown = 'slideDown',
  ZoomIn = 'zoomIn',
  ZoomOut = 'zoomOut',
  ScaleIn = 'scaleIn', //for scenes
  ScaleOut = 'scaleOut', //for scenes
  HandLeft = 'handLeft',
  HandRight = 'handRight',
  HandUp = 'handUp',
  HandDown = 'handDown',
  AutoType = 'autoType',
  AutoTypeWord = 'autoTypeWord',
}

/**
 * See https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit for definition of the terms used
 */
export enum ObjectFit {
  Contain = 'contain',    // Default, whole replacing image contained inside replaced object, letterboxed if needed
  Cover = 'cover',        // Whole replaced object covered by replacing image, cropped if needed
  Fill = 'fill',          // Fill whole replaced object with the replacing object, no respect for aspect ratio
  None = 'none',          // No fit, natural scale of replacing object (=1)
  ScaleDown = 'scaleDown' // As None or Contain, whichever results in the smaller concrete size
}

export namespace Tween {

  export function parse(tween: string): Tween {
    let result: string;
    for (const tweenObj in Tween) {
      if (tweenObj.toLowerCase() === tween.toLowerCase()) {
        result = tweenObj
      }
    }
    return Tween[result];
  }
}

export enum Easing {
  Linear = 'Linear',
  QuadraticIn = 'QuadraticIn',
  QuadraticOut = 'QuadraticOut',
  QuadraticInOut = 'QuadraticInOut',
  ElasticIn = 'ElasticIn',
  ElasticOut = 'ElasticOut'
}

export interface Def {
  id: string; // a unique identifier for the scene or wideo, globally unique (even outside the wideo)
  class: Class | string; // The class name of the Def, i.e. 'wideo' or 'scene' 
  width: number, // Native Pixel width, generally 1920
  height: number, // Native Pixel height, generally 1080
  version: number  // [major].[minor], step major for non backward compatible changes
}

export default interface WideoDef extends Def {
  createdFrom?: string;     // The id of the wideo that this wideo was created (cloned/reused/automated) from
  createdBy?: string;       // A reference to the software module that created this wideo
  timeStamp: number;        // the timestamp of the last change of this wideo
                            // represented as number of milliseconds since midnight,
                            // January 1, 1970 Universal Coordinated Time (UTC)
  sequenceNumber: number;   // Every save or alteration updates the sequenceNumber
  scenes: SceneDef[];       // A list of all the scenes in the video
  audios: WideoObjectDef[]; // A list of all the audio objects in the video, these audio object are wideo global and can thus span multiple scenes
  presentationMode: boolean;  // If true, the wideo is in presentation mode, meaning that the wideo is presented like a slide show rather than as a video
  colors?: WideoColorDef[]; // Optional ordered list of named colors for the wideo which can be used by automation to replace all instances of a color in the wideo
}

/* A Wideo Color object holds a named color that can be replaced by
   the editor, automation or any other client, example:
   {
     "name": "Primary",
     "color": "#FFFFFF"
    }
*/
export interface WideoColorDef {
  name: string, // The name of the color, typically primary, secondary, etc
  color: string // The color represented as RGB, example: "#4f4f4f"
}

export interface SceneDef extends Def, WideoObjectDef {
  thumbnail?: number; // Optional, the thumbnail time in the scene (scene local time) which is used by automation to generate a thumbnail of the scene
}

/* A WideoObjectDef represents any object that lives inside a Scene or a child object of a scene */
export interface WideoObjectDef {
  id: string; // a unique identifier for the object in the whole wideo
  name?: string; // A name for the object when it is used as a parameter for video automation. Any object with a name property set can be replaced with automation
  objectFit?: ObjectFit; // Optional, default is 'contain'. Used for placeholders and masked objects to control how the object is fitted into the placeholder            
  class: Class | string; // TODO: Represent this in the scema: Can be 'wideoObject', 'maskObject', 'objectGroup', 'maskedObject', 'placeholder', 'imageObject', 'textObject', 'shapeObject', 'animatedImageObject', 'animatedGroupObject', 'videoObject', 'audioObject'
  attributes: AttributesDef; // Attributes of the object that represents position, scale, rotation and alpha (transparency)
  startTime: number;              // Milliseconds relative to the parent object
  endTime: number;                // Milliseconds relative to the parent object
  components: ComponentDef[];     // A list of components that the object is composed of, there are some rules for which components can be combined with which objects
  objects: WideoObjectDef[];      // A list of objects that are children of this object, for example a group can contain multiple objects
  hidden: boolean;                // If true, the object is hidden
  locked: boolean;                // If true, the object is locked, meaning that it cannot be changed in the editor
  maskId?: string;                // Optional, the id of the mask object that is used to mask this object (must be a sibling)
  loop?: boolean;                 // Optional, if true, the object will loop
  interactivity?: WideoObjectInteractivityDef;
  fixScaleToMask?: boolean;       // Optional, if true, the object will be scaled to fit the mask once and then the property is deleted
                                  // (it used to indicate that the object has been created without renderer (AI) and the scale must be
                                  // set to fit the object to the mask, uses el objectFit property)
}

/* A Mask Object is used to mask other objects, typically images or videos in placeholders or MaskedObjects. The masked object must be
   a sibling of the object that it is masking and there must be a bi-directional relationship between the mask and the masked object. */
export interface MaskObjectDef extends WideoObjectDef {
  targetId: string; // The id of the object that is masked by this mask object (must be a sibling)
  width: number;    // The width of the mask object
  height: number;   // The height of the mask object
  type: MaskType;   // The type (shape) of the mask object
}

export interface TextObjectDef extends WideoObjectDef {
}

export interface WideoObjectInteractivityDef {
  url: string;
  newTab: boolean;
}

export interface AttributesDef {
  x: number;          // The x coordinate of the object relative to the center of the parent
  y: number;          // The y coordinate of the object relative to the center of the parent
  scaleX: number;     // The scale of the object in the x direction
  scaleY: number;     // The scale of the object in the y direction
  rotation: number;   // Describes how many radians the object is rotated counter clockwise around its center
  alpha: number;      // The alpha of the object expressed as a number between 0 and 1 where 0 is totally transparent and 1 is totally opaque
}

export interface ComponentDef {
  class: Class; // TODO: Create a interface for only component class names. i.e the class name of the component, i.e. 'mask', 'background', 'image', 'animatedImage', 'animatedGroup', 'transition', 'animation', 'text', 'audio', 'shape', 'video'
}

export interface AnimationComponentDef extends ComponentDef {
  class: Class; //'animation';
  animation: AnimationDef;
}

export interface AnimationDef {
  keyFrames: KeyFrameDef[];
}
export interface KeyFrameDef {
  id: string;
  attributes: AttributesDef;
  time: number;  // Milliseconds
  easing?: Easing; // Easing is optional, see KeyFrame.ts for default easing
}

export interface AudioComponentDef {
  id: string;
  class: Class; // 'audio'
  volume: number;
  repeat: boolean;
  src: string;
  fadeOut: boolean;
}

/* The MaskComponentDef is only used to mask other components inside an object. For example the TextComponent inside a TextObjects. To mask an entire object the MaskObject must be used.  */
export interface MaskComponentDef extends ComponentDef {
  class: Class;     //'mask'; // TODO: Create a interface for only MaskComponent class names.
  type: MaskType;   // The type (shape) of the mask object
  width: number;    // The width of the mask object
  height: number;   // The height of the mask object 
}

export interface BackgroundComponentDef extends ImageComponentDef {
  id: string;
  class: Class;       // 'background' | 'image'; //for now allow image since we inherit
  color?: string;      // "0xRRGGBB", either color or src need to be set
  keepRatio?: boolean; // only needed if src is set
  src?: string;        // either src or color needs to be set
}

export interface AnimatedGroupComponentDef extends ComponentDef {
  id: string;
  class: Class;
}

export interface ImageComponentDef extends ComponentDef {
  id: string;
  class: Class;       // 'image' | 'background'; //for now allow background since we inherit
  src?: string;       // optional because BackgroundComponent is inheriting ImageComponent
  loop?: boolean;     // Optional, since it is only applicable for Animated GIFs
  animated?: boolean; // Optional, if not present should be interpreted as true
}

export interface AnimatedImageComponentDef extends ComponentDef {
  id: string;
  class: Class;
  src: string;
}

export interface VideoComponentDef extends ComponentDef {
  id: string;
  class: Class; // 'video'
  src: string;
  fadeOut: boolean;
  volume: number;
  repeat: boolean;
}

export interface TextComponentDef extends ComponentDef {
  id: string;
  class: Class; //'text';
  text: string;
  width: number;
  height: number;
  style: TextStyleDef;
}

export interface TextStyleDef {
  align?: 'left' | 'center' | 'right';
  fill?: string;
  fontFamily?: string;
  fontSize?: number;
  fontStyle?: 'normal' | 'italic';
  fontWeight?: 'normal' | 'bold';
  lineHeightFactor?: number;
}

export interface TransitionComponentDef extends ComponentDef {
  class: Class; // 'transition';
  type: TransitionType; // 'intro' | 'outro';
  tween: Tween;
  length: number;  // milliseconds
}

export interface ScriptComponentDef extends ComponentDef {
  id: string;
  class: Class; // 'script';
  script: string;
  replicaId?: string;
}

export interface ShapeComponentDef extends ComponentDef {
  id: string;
  class: Class; //'shape';
  shapeType: ShapeType;
  borderColor: string; //RGBA (alpha channel is applied to border)
  borderAlpha: number;
  width: number;
  height: number;
  fillColor: string;
  fillAlpha: number;
  borderThickness: number;
  cornerRadius?: number;
}
